import { Channel, ChannelCustomer, Portfolio, UserData } from "@/@types/global";
import { SequenceType } from "@/app/flows/sequences/utils/enums";

export enum SequenceDistributionType {
  FIFO = 1,
  LIFO = 2,
}

export enum SequenceStatus {
  Active = 1,
  Inactive = 2,
}

export enum SequenceState {
  Pending = 1,
  InProgress = 2,
  Contacted = 3,
  NotContacted = 4,
}

export interface Schedule {
  weekday: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  start_hour: string;
  end_hour: string;
}

export interface Sequence {
  id: number;
  name: string;
  description: string;
  portfolio: Portfolio;
  distribution_type: SequenceDistributionType;
  priority_active: boolean;
  default_channel: Channel;
  channels_customers: (ChannelCustomer & { channel: Channel })[];
  schedules: Schedule[];
  users: number[];
  status: SequenceStatus;
  updated_at: string;
  sequence_type?: SequenceType;
  queue?: any;
  deleted_queues?: boolean;
  channels_balance?: any[];
}

export enum SequenceNodeAction {
  Finish = 1,
  MakeAutomaticCall = 2,
  SendWhatsapp = 3,
  SendSms = 4,
  SendEmail = 5,
  AddTimeInterval = 6,
}

export enum SequenceNodeType {
  TimeInterval = 1,
  AutomaticCall = 2,
  Whatsapp = 3,
  Sms = 4,
  Email = 5,
}

export interface SequenceNode {
  id: number;
  sequence: number;
  alias?: string;
  title?: string;
  node?: number | null;
  action: SequenceNodeAction;
  type: SequenceNodeType;
  waiting_time?: string | null;
  child: SequenceNode[];
  node_order: number;
  queue?: any;
  whatsapp_template?: { id: number; name: string };
  users?: any[] | undefined;
  message_type?: string | null;
  sms_message?: string | null;
  sms_template?: number | null;
  channel_customer?: any;
  email_subject?: string | null;
  email_template?: any;
  email_message?: string | null;
  attachments?: any;
  send_as_alias_identifier?: string | null;
  parameters?: Array<any>;
  media?: any;
}

export interface SequenceHistoryChange {
  id: number;
  user: UserData;
  created_at: string;
}

export interface SequenceDashboard {
  sequence_id: number;
  sequence_name: string;
  progress: { total: number; percent: number };
  call_statistics: { answered: number; no_contact: number };
  management_statistics: Record<string, number>;
}

export enum SequenceTypeMessage {
  UseTemplate = "template",
  ComposeMessage = "write",
}

export interface SequenceAgent {
  id: number;
  code_client: number;
  full_name: string;
  created_at: string;
  state: number;
  type: number;
}

export enum SequenceLeadsData {
  ContactedLeads = "contacted_leads",
  EndedLeads = "ended_leads",
  InProgressLeads = "in_progress_leads",
  PendingLeads = "pending_leads",
}

export enum SequenceLeadsStatusVoice {
  Answer = "answer",
  Dial = "dial",
  NoAnswer = "no_answer",
  WithoutPhone = "without_phone",
}

export enum SequenceLeadsStatusEmail {
  Sent = "sent",
  Open = "open",
  Click = "click",
  Answer = "answer",
  Failed = "failed",
  WithoutEmail = "without_email",
}

export enum SequenceLeadsStatusWhatsapp {
  Sent = "sent",
  Pending = "pending",
  Delivered = "delivered",
  Read = "read",
  Failed = "failed",
  WithoutPhone = "without_phone",
}

export enum SequenceLeadsStatusSms {
  Sent = "sent",
  Pending = "pending",
  Delivered = "delivered",
  Failed = "failed",
  WithoutPhone = "without_phone",
}
